import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import {NavLayout, SeoLayout} from '@layouts';
import {getConfigByApp} from '@utils';
import {metaInfo} from '@configs';
import {HOME, CHATS} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {wrapper} from '@jobseeker/common-core/stores';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import {Chats as MyChats} from '@components/Chat';
import {Box} from '@jobseeker/lotus/foundations';
import {AppState} from '@jobseeker/common-core/types';
import InjectSearchOverlay from '@components/SearchInjection';

type ChatsProps = {
  seoConfig: object;
};

const Chats = ({seoConfig}: ChatsProps) => {
  const metaData = getConfigByApp(metaInfo, HOME, true, CHATS);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch, true);

  const isSearchEnabled = useSelector(
    (state: AppState) => state.app.layout.searchOverlay,
    shallowEqual
  );

  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <InjectSearchOverlay isSearchEnabled={isSearchEnabled} />
        <Box mt={7} sx={{clear: 'both'}} height={'100vh'}>
          <MyChats />
        </Box>
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async () => {
    const seoConfig = await loadSEO(CHATS);

    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: CHATS},
    });

    return {
      props: {
        seoConfig,
      },
    };
  }
);

export default Chats;
